import {BsAward, BsCodeSlash, BsGearWideConnected, BsPhone, BsRobot, BsShop} from "react-icons/bs";
import React from "react";

export const APP_TITLE = "Pivot TechX";
export const SHORT_APP_TITLE = "PTS";
export const PTS_EMAIL = "pivottechx@gmail.com";
export const PTS_PHONE = "9043635749";
export const PTS_PHONE_DISPLAY = "+91 90436 35749";
export const PTS_WHATSAPP = "https://wa.me/919043635749";

export const servicesOffered = [
    {
        title: "Web Development",
        description:
            'We craft modern, high-performance web applications — fast, secure, and beautifully built to turn your idea into an impactful digital product.',
        icon: <BsCodeSlash size={35}/>,
    },
    {
        title: "Mobile App Development",
        description:
            "Native and cross-platform apps that reach your audience wherever they are, delivering seamless, engaging mobile experiences on every device.",
        icon: <BsPhone size={35}/>,
    },
    {
        title: "AI & Automation",
        description:
            "Leverage GenAI, smart chatbots, and workflow automation to boost productivity and give your customers a future-ready, intelligent experience.",
        icon: <BsRobot size={35}/>,
    },
    {
        title: "E-Commerce",
        description:
            "Launch a high-converting online store with payments, inventory, and a checkout experience your customers will love — built to scale with you.",
        icon: <BsShop size={35}/>,
    },
    {
        title: "DevOps & Cloud",
        description:
            "Faster releases, rock-solid security, and scalable infrastructure through modern CI/CD, cloud-native practices, and 24/7 reliability.",
        icon: <BsGearWideConnected size={35}/>,
    },
    {
        title: "UI/UX Design",
        description:
            "Design-led, user-first interfaces that look stunning and convert — turning complex journeys into simple, delightful experiences.",
        icon: <BsAward size={35}/>,
    },
];